import React, { useState } from "react";
import "../Styles/ArtistInfo.css";
import { Row, Col } from "react-bootstrap";

// 🎵 Import all artist images
import shemekiacopeland from "../Assets/lineup/ShemekiaCopeland.jpg";
import ericgales from "../Assets/lineup/EricGales.jpg";
import mattschofield from "../Assets/lineup/MattSchofield.jpg";
import alteredfivebluesband from "../Assets/lineup/AlteredFiveBluesBand.jpg";
import dkharrell from "../Assets/lineup/DKHarrell.jpg";
import blackstratblues from "../Assets/lineup/Blackstratblues.jpg";

// 🧩 Artist Data Array
const artists = [
  {
    id: 1,
    name: "Shemekia Copeland",
    subHeading: "The fearless voice of modern blues and roots music. “The greatest blues singer of her generation.” – The Washington Post",
    image: shemekiacopeland,
    side: "left",
    about: [
      "Shemekia Copeland possesses one of the most instantly recognizable and deeply soulful voices in roots music today. The multi-GRAMMY nominee is beloved for the fearlessness, honesty, and humor of her revelatory songs and her engaging personality. The Chicago Tribune calls her “the greatest female blues vocalist working today,” while Rolling Stone declares, “She can do no wrong.”",
      "Her new album Blame It On Eve recorded in Nashville and produced by Will Kimbrough features 12 new songs that hit hard, from the autobiographical Tough Mother to the anthemic title track and the playful Wine O’Clock. Special guests include Jerry Douglas, DaShawn Hickman, and Alejandro Escovedo. The album showcases Copeland’s mix of gospel, rock, blues, soul, and Americana — what she calls “the brighter side” of her blues.",
    ],
    more: [
      "Born in Harlem in 1979, Copeland first performed with her father, bluesman Johnny Copeland, at eight. Her Alligator Records debut at 18 launched a stellar career that has earned five GRAMMY nominations, multiple Blues Music and Living Blues Awards, and worldwide acclaim. She’s performed with legends like Bonnie Raitt, Keith Richards, and B.B. King, entertained U.S. troops, sung at the White House, and continues to inspire globally as a powerhouse vocalist and fearless truth-teller.",
    ],
  },
  {
    id: 2,
    name: "Eric Gales",
    subHeading: "The Left-Handed Force of Nature in Modern Blues.",
    image: ericgales,
    side: "right",
    about: [
      "Eric Gales grew up in a musical family with four brothers, two of whom learned to play guitar upside down and left-handed just like him. He released his first record at age 16 on Elektra Records to an amazing response from media and fans around the globe. Guitar World Magazine’s Reader’s Poll named him Best New Talent in 1991. After his second record, the three brothers teamed up as The Gales Bros",
      "Over the years, it wasn’t unusual to find Carlos Santana, Eric Johnson, B.B. King, or Eric Clapton in the audience, watching Eric work the crowd into a frenzy. In 2001, he signed with Nightbird Records, releasing That’s What I Am to critical acclaim. He followed with Crystal Vision (2006), The Psychedelic Underground (2007), Relentless (2010), Transformation (2011), and Good for Sumthin’ (2014), produced by Raphael Saadiq, later releasing A Night on the Sunset Strip (2016).",
    ],
    more: [
      "Since joining Mascot Label Group, Eric has released Middle of the Road (2018) and The Bookends (2019), both deeply personal works. A left-handed blues-rock virtuoso, Eric Gales stands tall among the greatest guitarists of his generation.",
    ],
  },
  {
    id: 3,
    name: "Matt Schofield",
    subHeading: "Redefining the sound and soul of modern British Blues.",
    image: mattschofield,
    side: "left",
    about: [
      "British-born and now US-based, Matt Schofield continues to push the frontiers and reshape the boundaries of the British Blues tradition. A multi-award-winning guitar virtuoso, singer, songwriter, producer, and band leader, his impact as one of the most influential and distinctive guitarists of his generation is unquestionable.",
      "His storied career, which has taken him and his band to nearly 30 countries worldwide, has earned him awards, industry, and critical acclaim — three-time British Blues Guitarist of the Year, British Blues Album of the Year, and the first guitarist inducted into the British Blues Awards Hall of Fame. His work has earned Mojo Magazine’s Blues Album of the Year and Guitar & Bass Magazine’s Top Ten British Blues Guitarists of All Time alongside Eric Clapton and Peter Green.",
    ],
    more: [
      "Schofield’s fluid, melodic playing and iconic tone have inspired legions of guitarists and a line of signature instruments and equipment, including the Two-Rock Matt Schofield amplifier. From major festivals such as Montreal and North Sea Jazz to iconic clubs like New York’s Iridium and London’s 100 Club, his authenticity, mastery of guitar, and improvisational brilliance are unforgettable.",
      "A renowned musical educator, Schofield released Blues Speak with TrueFire in 2018. His upcoming record reunites his original organ trio to mark its 20th anniversary. ",
    ],
  },
  {
    id: 4,
    name: "Altered Five Blues Band",
    subHeading: "Blues that hits hard and burns slow.",
    image: alteredfivebluesband,
    side: "right",
    about: [
      "Altered Five smokes, smolders, and burns like a swig of good whiskey. The Milwaukee quintet is known for its strong brew of tough, original blues and hard-hitting live shows. Blues Blast raves that frontman Jeff Taylor possesses a “smooth, warm-toned voice as monumental and undeniable as Howlin’ Wolf with the finish and flourish of B.B. King,” while Downbeat hails guitarist Jeff Schroedl for “reaching the high bar of mixed invention and fluidity.”",
      "Fueled by a rhythm section laying down the deepest grooves this side of the MGs, the band hit the ground running 20 years ago and shows no sign of easing up. Their seventh studio recording, Testifyin’, released March 22, 2024, on Blind Pig Records, kicks hard like the four award-winning records before it. ",
    ],
    more: [
      "Cryin’ Mercy won Best Self-Released Album at the International Blues Challenge (2015); Charmed & Dangerous earned Song of the Year at both the Independent and Wisconsin Music Awards (2018); Ten Thousand Watts hit #10 on the Billboard Blues Chart and #1 on iTunes and Amazon Blues Charts; and Holler If You Hear Me debuted at #3 and earned three Blues Music Award nominations.",
      "Known for incisive songwriting and powerhouse performances, Altered Five continue to deliver deeply expressive, original blues with passion, precision, and soul.",
    ],
  },
  {
    id: 5,
    name: "D.K. Harrell",
    subHeading: "Carrying the Blues into a New Generation.",
    image: dkharrell,
    side: "left",
    about: [
      "D.K. Harrell, Louisiana’s new bluesman, is a guitarist, vocalist, and songwriter whose stinging single-note bends, deep-soul vocals, and original songs make him one of the most formidable young stars of today’s blues resurgence. Critics call him “a leading light of the younger generation of blues artists,” with a “fully realized sound enriched by unselfconscious virtuosity.”",
      "With his Alligator Records debut, Talkin’ Heavy, Harrell cements his place among the new generation of blues players. The album produced by Christoffer “Kid” Andersen features twelve original tracks filled with biting guitar work, church-born vocals, and emotion-packed energy. Songs like A Little Taste, Grown Now, and Praise These Blues affirm the sheer power of modern blues.",
    ],
    more: [
      "Born in Ruston, Louisiana in 1998, Harrell first heard B.B. King at age two and soon began writing his own songs. His debut, The Right Man (2023), drew rave reviews and earned him the Blues Music Award for Best Emerging Artist. In 2022, he won the B.B. King Of The Blues Award for Preserving Traditional Blues Heritage.",
      "Having toured across the U.S., Canada, and Europe, Harrell is hailed as “the fastest-rising talent in the blues today.” With Talkin’ Heavy and more than 20 festivals already booked for 2025, D.K. Harrell is carrying the blues into a new generation.",
    ],
  },
  {
    id: 6,
    name: "Blackstratblues",
    subHeading: "The Sound of Pure, Live Emotion.",
    image: blackstratblues,
    side: "right",
    about: [
      "Blackstratblues is a solo project of Warren Mendonsa, guitarist, songwriter, producer and recording engineer. The lineup includes Jai Row Kavi on drums, Adi Mistry on bass and Beven Fonseca on keys. Their music is predominantly instrumental, blending Blues, Rock and 70’s Psychedelia with strong melodic and occasional electronic influences.",
      "The band has played prestigious gigs such as NH7 (2010–2017), Sulafest 2012, Indigo & Blues 2012, and Mahindra Blues Fest (2012–2018), sharing the stage with heroes like Tedeschi Trucks Band and Doyle Bramhall II. Warren also jammed with Billy Gibbons (ZZ Top) and John Mayall during the all-star jams.",
    ],
    more: [
      "Blackstratblues has released six albums: Nights In Shining Karma (2007), The New Album (2009), The Universe Has a Strange Sense of Humour (2015), The Last Analog Generation (2017), When It’s Time (2019), and Hindsight is 2020 (2021). The albums topped the iTunes India charts, with The Last Analog Generation reaching #1 across genres. Their first live album, L.I/O.V.E., was released in 2022.",
    ],
  },
  
  
];

function ArtistInfo() {
  const [expanded, setExpanded] = useState({});

  const toggleReadMore = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section className="artist_info_main">
      <div className="mbspace">
        <h3
          data-aos="fade-up"
          data-aos-easing="ease-in"
          data-aos-duration="2000"
          className="galleryMainHead"
        >
          ARTIST LINEUP
        </h3>
      </div>

      {artists.map((artist, index) => {
        const isLeft = artist.side === "left";
        const isExpanded = expanded[artist.id];

        return (
          <Row
            key={artist.id}
            data-aos="fade-up"
            data-aos-duration="2000"
            className={`alignMiddle ${index % 2 !== 0 ? "spacearl" : ""}`}
          >
            {/* Always Image First on Mobile */}
            <Col
              sm={12}
              xs={12}
              md={{ span: 5, order: isLeft ? 1 : 2 }}
              lg={{ span: 5, order: isLeft ? 1 : 2 }}
              xl={{ span: 5, order: isLeft ? 1 : 2 }}
            >
              <div className="center">
                <img
                  src={artist.image}
                  alt={artist.name}
                  className="new_img_ar"
                />
              </div>
            </Col>

            {/* Text Content */}
            <Col
              sm={12}
              xs={12}
              md={{ span:7, order: isLeft ? 2 : 1 }}
              lg={{ span: 7, order: isLeft ? 2 : 1 }}
              xl={{ span: 7, order: isLeft ? 2 : 1 }}
            >
              <p className="artistnamem">{artist.name}</p>
              {artist.subHeading && (
                <p className="artistnamemsh">{artist.subHeading}</p>
              )}

              <div className="aboutartist">
                {artist.about.map((para, i) => (
                  <p key={i}>{para}</p>
                ))}

                {artist.more && isExpanded && (
                  <>
                    {artist.more.map((para, i) => (
                      <p key={i}>{para}</p>
                    ))}
                  </>
                )}
              </div>

              {artist.more && (
                <button
                  onClick={() => toggleReadMore(artist.id)}
                  className="stylereadmrebtn"
                >
                  {isExpanded ? "Read less" : "Read more"}
                </button>
              )}
            </Col>
          </Row>
        );
      })}
    </section>
  );
}

export default ArtistInfo;
